module.exports = __webpack_public_path__ + "img/typolibris.353210d0.png";